<template>
  <div :class="$style.timeline">
    <div
      v-if="isShowModal && screenData.length"
      :class="$style.containerScreen"
    >
      <log-screen
        v-for="log in screenData"
        :ref="`logDetails-${log.ref}`"
        :key="log.ref"
        :data="log"
      />
    </div>

    <div :class="{ [$style.containerDraggable]: isShowModal && screenData.length }">
      <advanced-list
        v-if="isViewList"
        :data="{ name: $t('computers.allData') }"
        :is-show-modal="isShowModal"
        :is-screen="!!screenData.length"
      >
        <log-details
          v-for="log in logsData"
          :ref="`logDetails-${log.ref}`"
          :key="log.ref"
          :data="log"
          :is-ref="isRef"
          :current-time="currentAudioTime"
          @playAudio="playAudio(log)"
          @pauseAudio="pauseAudio()"
        />
      </advanced-list>
      <draggable
        v-else
        :class="$style.draggableBoard"
      >
        <advanced-list
          v-for="(logs, index) in logsData"
          :key="index"
          :data="logs[0]"
          :is-show-modal="isShowModal"
        >
          <log-details
            v-for="log in logs"
            :ref="`logDetails-${log.ref}`"
            :key="log.ref"
            :data="log"
            :is-ref="isRef"
            :current-time="currentAudioTime"
            @playAudio="playAudio(log)"
            @pauseAudio="pauseAudio()"
          />
        </advanced-list>
      </draggable>
    </div>
    <div
      v-if="isViewTimline"
      :class="{ [$style.containerTimlane]: isShowModal && screenData.length > 0 }"
    >
      <div :class="$style.item">
        <button-blue-icon @click="moveButton('back')">
          <inline-svg
            :src="require('@/assets/images/icons/computer/screenshots/modal/next.svg')"
            :alt="$t('computers.back')"
            :title="$t('computers.back')"
            :class="[$style.playSvg, $style.goBack]"
          />
        </button-blue-icon>
        <button-blue-icon
          v-if="!isPlaying"
          @click="playTimline()"
        >
          <inline-svg
            :src="require('@/assets/images/icons/computer/screenshots/modal/play.svg')"
            :alt="$t('computers.playback')"
            :title="$t('computers.playback')"
            :class="$style.playSvg"
          />
        </button-blue-icon>

        <button-blue-icon
          v-else
          @click="pauseTimline()"
        >
          <inline-svg
            :src="require('@/assets/images/icons/computer/screenshots/modal/pause.svg')"
            :alt="$t('computers.stop')"
            :title="$t('computers.stop')"
            :class="$style.playSvg"
          />
        </button-blue-icon>
        <button-blue-icon @click="moveButton('next')">
          <inline-svg
            :src="require('@/assets/images/icons/computer/screenshots/modal/next.svg')"
            :alt="$t('computers.forward')"
            :title="$t('computers.forward')"
            :class="$style.playSvg"
          />
        </button-blue-icon>
        <button-blue-icon
          :class="$style.fullScreen"
          :disabled="pause === 5000"
          @click="pauseValue(5000)"
        >
          {{ $t('computers.slow') }}
        </button-blue-icon>
        <button-blue-icon
          :class="$style.fullScreen"
          :disabled="pause === 3000"
          @click="pauseValue(3000)"
        >
          {{ $t('computers.normal') }}
        </button-blue-icon>
        <button-blue-icon
          :class="$style.fullScreen"
          :disabled="pause === 500"
          @click="pauseValue(500)"
        >
          {{ $t('computers.fast') }}
        </button-blue-icon>

        <button-blue-icon
          v-if="!isShowModal"
          :class="$style.fullScreen"
          @click="openFullScreen"
        >
          {{ $t('computers.fullScreen') }}
        </button-blue-icon>
      </div>

      <div
        ref="containerLine"
        :class="$style.containerLine"
        @wheel="handleWheel"
      >
        <div
          ref="wrapperLine"
          :class="$style.wrapperLine"
        >
          <svg :class="$style.svg">
            <rect
              ref="mainLine"
              :class="$style.mainLine"
            />
          </svg>
          <svg :class="$style.cursor">
            <image
              :x="cursor.x"
              :class="$style.cursorSvg"
              href="@/assets/images/icons/computer/screenshots/additional-angle.svg"
            />
          </svg>
          <svg :class="$style.ruler">
            <g
              v-for="(time, index) in ruler"
              :key="index"
            >
              <text
                v-if="time.day"
                :class="$style.day"
                :x="time.x + '%'"
              >
                {{ time.day }}
              </text>
              <text
                v-if="time.time"
                :class="$style.text"
                :x="time.x + '%'"
              >
                {{ time.time }}
              </text>
              <rect
                :x="time.x + '%'"
                y="20%"
                :class="$style.rulerLine"
              />
            </g>
          </svg>
          <svg :class="$style.lines">
            <g
              v-for="(event, index) in lines"
              :key="index"
            >
              <rect
                :x="event.x"
                :class="$style.line"
                :fill="event.color"
                @click.prevent="move(event)"
                @mouseover="showEventInfo(event)"
                @mouseleave="hideEventInfo()"
                @mousemove="mouseMove"
              />
            </g>
          </svg>
          <div />
        </div>
      </div>

      <div
        v-if="currentEvent"
        :class="$style.infoContainer"
        :style="{
          border: `1px solid ${currentEvent.color}`,
          top: mouseY + 'px',
          left: mouseX + 'px',
        }"
      >
        <div :style="{ color: currentEvent.color }">
          {{ currentEvent.logName }}
        </div>
        <div
          v-for="fieldItem in logTypes[currentEvent.logId].slice(0, 3)"
          :key="fieldItem.field"
          :class="$style.detailsItem"
        >
          <div :class="$style.itemHeader">
            {{ fieldItem.text }}:
          </div>
          <div :class="$style.itemContent">
            {{ currentEvent[fieldItem.field] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getMicRecordAudioPlay } from '@/api/methods/computers';
  /* eslint-disable no-await-in-loop */
  import draggable from 'vuedraggable';
  import { logTypes } from '@/assets/scripts/dictionaries';
  import { InlineSvgComponent } from 'vue-inline-svg';
  import ButtonBlueIcon from '@/components/common/button/button-blue-icon.vue';
  import LogDetails from '@/components/common/table/log-details-advanced.vue';
  import LogScreen from '@/components/common/table/log-details-screen.vue';
  import { deleteFile, addFile } from '@/api/methods/audio';
  import { LOG_TYPES_DETAILS } from '@/assets/scripts/details';
  import dayjs from 'dayjs';

  import { getDateUTC } from '@/helpers/format-date';
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import AdvancedList from './advancedList.vue';

  Vue.use(VueToast);

  export default {
    components: {
      inlineSvg: InlineSvgComponent,
      ButtonBlueIcon,
      AdvancedList,
      LogDetails,
      LogScreen,
      draggable,
    },
    props: ['data', 'selectedLogs', 'isShowModal', 'isViewTimline'],
    data: () => ({
      player: '',
      currentAudio: null,
      currentAudioTime: 0,
      isRef: '',
      ruler: [],
      isPlaying: false,
      isAudio: false,
      cursor: { x: 0 },
      pause: 3000,
      lines: [],
      logsData: [],
      screenData: [],
      isDragging: false,
      initialWidth: 100,
      dragStartY: 0,
      minWidth: 100,
      maxWidth: 1000,
      timeNum: 2,
      step: 12,
      isScroll: false,
      currentEvent: null,
      hoverRef: null,
      mouseX: 0,
      mouseY: 0,
    }),
    computed: {
      isViewList() {
        return (
          this.isShowModal &&
          ((this.screenData.length && this.selectedLogs.length > 1) ||
            (!this.screenData.length && this.selectedLogs.length))
        );
      },
      logTypes() {
        return LOG_TYPES_DETAILS;
      },
      dateRange() {
        const { dateFrom, dateTo } = getDateUTC(this.$route.query.dateFrom, this.$route.query.dateTo);
        return { dateFrom, dateTo };
      },
      daysNumber() {
        return this.dateRange.dateTo.diff(this.dateRange.dateFrom, 'day') + 1;
      },
      oneSecondPercent() {
        return 1 / (this.daysNumber * 24 * 36);
      },
    },
    watch: {
      data() {
        if (this.isViewTimline) {
          this.$refs.wrapperLine.style.width = `${this.minWidth}%`;
          this.$refs.mainLine.style.width = `${this.minWidth}%`;
        }
        this.fetch();
      },
    },
    created() {
      this.fetch();
    },
    beforeDestroy() {
      clearInterval(this.timerInterval);
      deleteFile();
    },
    methods: {
      openFullScreen() {
        this.$emit('openFullScreen');
      },

      mouseMove(event) {
        this.mouseX = event.clientX - 150;
        this.mouseY = event.clientY - 150;
      },
      showEventInfo(event) {
        this.currentEvent = event;
      },
      hideEventInfo() {
        this.currentEvent = null;
      },
      timer(data) {
        const updateAudioTime = () => {
          if (this.currentAudioTime === data) {
            this.pauseAudio();
            clearInterval(this.timerInterval);
          } else {
            this.currentAudioTime += 1;
            this.timerInterval = setTimeout(updateAudioTime, 1000);
          }
        };

        updateAudioTime();
      },
      async playAudio(data) {
        this.isAudio = true;
        this.currentAudio = data;
        this.currentAudioTime = 0;
        clearInterval(this.timerInterval);
        const response = await getMicRecordAudioPlay(data.compId, data.id);

        if (!response.success) {
          let message;
          if (response.status === 404) message = this.$t('toast.audioFileNotFound');
          else message = this.$t('toast.unknownError');
          Vue.$toast.open({
            message,
            type: 'error',
          });
        } else {
          await this.uploadFile(response);
          const link = `api/${response.headers.filename}`;
          this.player = new Audio(link);
          this.player.load();
          this.player.play();
          this.timer(data.duration);
          this.linkAudio = link;
          this.isRef = data.ref;
        }
      },
      pauseAudio() {
        this.isAudio = false;
        this.currentAudio = null;
        this.currentAudioTime = 0;
        if (this.player) {
          this.player.pause();
          this.player = '';
          this.isRef = '';
        }
      },
      async uploadFile(response) {
        const audioBlob = new Blob([response.data], { type: 'audio/mp3' });
        const formData = new FormData();
        formData.append('audio', audioBlob, response.headers.filename);
        await addFile(formData);
      },
      pauseValue(value) {
        this.pause = value;
      },
      handleWheel(event) {
        event.preventDefault();
        const delta = event.deltaY;
        const newWidth = this.initialWidth - delta;
        this.updateWidth(newWidth);

        const { wrapperLine } = this.$refs;
        const { containerLine } = this.$refs;
        const cursorX = event.clientX;
        const wrapperRect = wrapperLine.getBoundingClientRect();
        const containerRect = containerLine.getBoundingClientRect();
        containerLine.scrollLeft = delta > 0 ? cursorX - containerRect.left : cursorX - wrapperRect.left;
      },
      updateWidth(newWidth) {
        if (this.daysNumber === 1) {
          this.isScroll = true;
          if (this.initialWidth >= 100 && this.initialWidth <= 300) {
            this.timeNum = 24;
            this.step = 1;
          }
          if (this.initialWidth > 300) {
            this.timeNum = 96;
            this.step = 0.25;
          }
          this.fetch();
          if (newWidth >= this.maxWidth) {
            newWidth = this.maxWidth;
            this.isScroll = false;
          } else if (newWidth <= this.minWidth) {
            newWidth = this.minWidth;
            this.timeNum = 4;
            this.step = 6;
            this.fetch();
          }
          this.initialWidth = newWidth;
          this.$refs.wrapperLine.style.width = `${newWidth}%`;
          this.$refs.mainLine.style.width = `${newWidth}%`;
          this.isScroll = false;
        }
      },
      fetch() {
        const days = this.daysNumber;
        this.ruler = [{ x: 0, day: this.dateRange.dateFrom.format('DD.MM') }];

        if (days > 7 && days < 15) {
          for (let i = 1; i < days; i++) {
            this.ruler.push({
              x: (100 / days) * i,
              day: this.dateRange.dateFrom.add(i, 'day').format('DD.MM'),
            });
          }
        } else if (days < 8) {
          if (days < 3 && !this.isScroll) {
            this.timeNum = 4;
            this.step = 6;
          }
          let time = 0;
          let day = 1;
          const linesNum = days * this.timeNum;

          for (let i = 1; i < linesNum; i++) {
            time += this.step;
            if (time > 24) {
              time -= 24;
              day++;
            }

            if (time !== 24) {
              if (this.initialWidth <= 300) {
                this.ruler.push({ x: (100 / linesNum) * i, time: `${time}:00` });
              } else {
                const hours = Math.floor(time);
                const minutes = (i % 4) * 15;
                const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

                this.ruler.push({ x: (100 / linesNum) * i, time: formattedTime });
              }
            } else {
              this.ruler.push({
                x: (100 / linesNum) * i,
                day: this.dateRange.dateFrom.add(day, 'day').format('DD.MM'),
              });
            }
          }
        }

        if (this.data.length > 0 && !this.isScroll) {
          this.lines = this.data;

          this.lines.forEach((line) => {
            const { color } = logTypes.find((log) => log.id === line.logId);

            const date = dayjs(new Date(line.date));
            const diff = date.diff(this.dateRange.dateFrom, 'second');
            const x = diff * this.oneSecondPercent;
            line.x = `${x}%`;
            line.color = color;
          });
          const { x } = this.lines[0];
          const eventRef = this.lines[0].ref;
          this.cursor = { x, eventRef, index: 0 };
        }

        if (!this.isScroll) this.getLogData();
      },
      timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      scroll(ref) {
        const logDetailsElement = this.$refs[`logDetails-${ref}`][0];
        if (logDetailsElement) {
          logDetailsElement.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
          logDetailsElement.$el.blur();
        }
      },

      move(event) {
        const { x } = event;
        const { ref } = event;
        const index = this.lines.findIndex((line) => line.ref === ref);
        this.cursor = { x, ref, index };
        this.scroll(ref);
      },
      moveButton(direction) {
        this.pauseAudio();
        const current = this.lines.findIndex((line) => line.ref === this.cursor.ref);
        let newIndex;

        if (direction === 'back' && current > 0) {
          newIndex = current - 1;
        } else if (direction === 'next' && current < this.lines.length - 1) {
          newIndex = current + 1;
        }

        if (newIndex !== undefined) {
          const currentLine = this.lines[newIndex];
          const { x, ref } = currentLine;
          this.cursor = { x, ref, index: newIndex };
          this.scroll(ref);
        }
      },
      async playTimline() {
        this.isPlaying = true;
        for (let i = this.cursor.index; i < this.lines.length; i++) {
          if (this.isPlaying) {
            if (this.cursor.index !== i) i = this.cursor.index;
            const { x } = this.lines[i];
            const { ref } = this.lines[i];
            const index = i + 1;
            this.cursor = { x, ref, index };
            this.scroll(ref);

            let { pause } = this;

            if (this.lines[i].logId === 27) {
              await this.playAudio(this.lines[i]);
            }
            let nextStep = 0;
            if (this.currentAudio && this.lines[i + 1]) {
              nextStep = new Date(this.lines[i + 1].date).getTime() - new Date(this.currentAudio?.endDate).getTime();
            }
            if (nextStep > 0) {
              this.isAudio = false;
              const step = new Date(this.currentAudio?.endDate).getTime() - new Date(this.lines[i].date).getTime();
              pause = step + 3000;
            }
            if (this.isAudio) {
              let time;
              if (this.lines[i + 1]) {
                time = new Date(this.lines[i + 1].date).getTime() - new Date(this.lines[i].date).getTime();
              } else {
                time = this.currentAudio.duration * 1000;
              }
              if (time > this.currentAudio.duration * 1000) {
                pause = this.currentAudio.duration * 1000;
                this.isAudio = false;
              } else {
                pause = time;
              }
            }

            await this.timeout(pause);
          }
        }
        this.pauseTimline();
      },
      pauseTimline() {
        this.pauseAudio();
        this.isPlaying = false;
        this.pause = 3000;
      },

      getLogData() {
        this.logsData = [];
        this.screenData = [];
        if (this.isShowModal) {
          if (this.selectedLogs.includes(2)) {
            this.data.forEach((item) => {
              if (item.logId === 2) {
                this.screenData.push(item);
              } else {
                this.logsData.push(item);
              }
            });
          } else {
            this.logsData = this.data;
          }
        } else {
          this.logsData = this.selectedLogs.map((logId) => this.data.filter((item) => item.logId === logId));
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .timeline {
    position: relative;
  }
  .containerScreen {
    position: absolute;
    overflow-x: hidden;
    height: 850px;
    width: 100%;
  }
  .containerDraggable {
    position: absolute;
    top: 0;
    right: 0;
  }
  .containerTimlane {
    position: absolute;
    bottom: -950px;
    width: 100%;
  }
  .containerLine {
    overflow-x: auto;
  }

  .wrapperLine {
    display: inline-block;
    width: 100%;
  }
  .draggableBoard {
    display: grid;
    grid-template-columns: 30% 40% 30%;
    column-gap: 15px;
    row-gap: 15px;
    padding: 30px 40px;
  }
  .svg {
    margin-left: 5%;
    width: 90%;
  }

  .mainLine {
    height: 5px;
    y: 90%;
    width: 100%;
  }

  .lines {
    position: relative;
    width: 90%;
    margin-left: 5%;
    margin-top: -118px;
  }

  .ruler {
    width: 90%;
    margin-left: 5%;
    margin-top: -62px;
    overflow: visible;
  }

  .line {
    width: 3px;
    height: 30px;
    cursor: pointer;
  }
  .infoContainer {
    display: flex;
    flex-direction: column;
    gap: 11px;
    overflow: hidden;
    border-radius: 4px;
    padding: 10px;
    width: 300px;
    height: fit-content;
    position: fixed;
    z-index: 1000;
    background-color: #fff;
  }

  .detailsItem {
    display: grid;
    grid-template-columns: 40% 60%;
    font-size: 14px;
  }

  .itemHeader {
    font-weight: 500;
    min-width: 100px;
  }

  .itemContent {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rulerLine {
    width: 2px;
    height: 30px;
  }

  .day {
    font-weight: 500;
  }

  .item {
    display: flex;
    justify-content: center;
    margin-bottom: -40px;
    margin-right: 10px;
    position: relative;
    z-index: 10;
    gap: 10px;
  }

  .playSvg {
    height: 15px;
    width: 15px;
    color: #2985bf;
  }
  .goBack {
    transform: rotate(180deg);
  }
  .fullScreen {
    color: #2985bf;
  }

  .cursor {
    position: relative;
    left: -8px;
    margin-top: -50px;
    width: 90%;
    height: 50px;
    margin-left: 5%;
    overflow: visible;
  }

  .cursorSvg {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
</style>

<style>
  .button-blue-icon_button_3_TlE {
    padding: 15px;
  }
</style>
